export default function Image (props) {
  return (
    <img src={props.image} alt="..." />
  )
}